import { Desktop, Moon, Sun } from './icons';
import { useTheme, type ThemePreference } from '@/core/theme/theme';
import { cn } from './cn';

const OPTIONS: { id: ThemePreference; label: string; icon: typeof Sun }[] = [
  { id: 'light', label: 'Claro', icon: Sun },
  { id: 'dark', label: 'Escuro', icon: Moon },
  { id: 'system', label: 'Sistema', icon: Desktop },
];

/** Seletor de tema em três posições (claro, escuro, sistema). */
export function ThemeSegmented({ className }: { className?: string }) {
  const { preference, setTheme } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Tema"
      className={cn('grid grid-cols-3 gap-1 rounded-xl bg-surface-2 p-1', className)}
    >
      {OPTIONS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={preference === id}
          onClick={() => setTheme(id)}
          className={cn(
            'flex items-center justify-center gap-1.5 rounded-lg px-2 py-1.5 text-xs font-medium transition-colors',
            preference === id ? 'bg-surface-3 text-fg' : 'text-fg-subtle hover:text-fg',
          )}
        >
          <Icon aria-hidden className="size-3.5" />
          {label}
        </button>
      ))}
    </div>
  );
}

/** Botão único que alterna claro/escuro — para cabeçalhos enxutos. */
export function ThemeToggleButton({ className }: { className?: string }) {
  const { resolved, setTheme } = useTheme();
  const next = resolved === 'dark' ? 'light' : 'dark';
  const Icon = resolved === 'dark' ? Sun : Moon;
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={next === 'light' ? 'Mudar para o tema claro' : 'Mudar para o tema escuro'}
      title={next === 'light' ? 'Tema claro' : 'Tema escuro'}
      className={cn(
        'flex size-9 items-center justify-center rounded-xl bg-surface-2 text-fg-muted transition-colors hover:bg-surface-3 hover:text-fg',
        className,
      )}
    >
      <Icon aria-hidden className="size-4" />
    </button>
  );
}
